import SwitchIcon from "@assets/svg/SwitchIcon";
import { RootState } from "@store/reducers";
import { useDispatch, useSelector } from "react-redux";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
import { loginUser } from "@store/actions/auth.action";
import { fetchLinkedToken } from "@endpoints/auth.service";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { useState } from "react";
import { EnumUserTypes } from "@utils/constants";
import { Link } from "react-router-dom";

const SwitchAccountSection = () => {
  const dispatch = useDispatch();
  const user = useSelector((state: RootState) => state.auth.user);
  const linkedAccount = useSelector(
    (state: RootState) => state.auth.linkedAccount
  );
  const [switchingAccount, setSwitchingAccount] = useState(false);

  const onClickLinkedAccount = async () => {
    setSwitchingAccount(true);
    try {
      const { data } = await fetchLinkedToken();
      dispatch(loginUser(data));
      window.location.reload();
    } catch (error) {
      console.error("Error: switching account", error);
    } finally {
      setSwitchingAccount(false);
    }
  };

  console.log("linked account", linkedAccount, user);

  return (
    <>
      <div className="bg-white flex items-center justify-between rounded-md p-3">
        <div className="flex items-center gap-3">
          {user?.profilePic ? (
            <img src={user?.profilePic} className="w-10 h-10 rounded-full" />
          ) : (
            <div className="flex items-center justify-center font-semibold bg-gray-100 text-primary w-10 h-10 rounded-full">
              {user?.firstName?.charAt(0)}
            </div>
          )}
          <div className="flex flex-col">
            <span className="font-semibold">
              {user?.firstName} {user?.lastName}
            </span>
            <span className="font-medium text-xs text-light-black capitalize">
              {EnumUserTypes[user?.userType]?.replace("_", " ").toLowerCase()}{" "}
              Account
            </span>
          </div>
        </div>
        {/* Online Badge */}
        <div className="flex items-center justify-center font-medium text-xs bg-[#00CF3E2E] text-[#02A633] border border-[#00CF3E] px-2 py-1 rounded-full">
          Active session
        </div>
      </div>

      {linkedAccount?._id ? (
        // Switch account
        <>
          <button
            onClick={onClickLinkedAccount}
            className="group flex items-center justify-center gap-2 font-semibold text-sm text-primary bg-white rounded-md px-5 py-2.5 w-max mx-auto hover:scale-105 hover:bg-gray-200 duration-500"
          >
            Switch accounts
            {switchingAccount ? (
              <LoadingAnimation color="black" />
            ) : (
              <div className="group-hover:rotate-180 ease-in-out duration-500 transition-all">
                <SwitchIcon className="w-4 h-4" />
              </div>
            )}
          </button>
          <div className="bg-white flex items-center justify-between rounded-md p-3 w-full">
            <div className="flex items-center gap-3">
              {linkedAccount?.profilePic ? (
                <img
                  src={linkedAccount?.profilePic}
                  className="w-10 h-10 rounded-full"
                />
              ) : (
                <div className="w-10 h-10 rounded-full flex justify-center items-center bg-gray-200 text-primary font-semibold text-lg">
                  {linkedAccount?.firstName?.charAt(0)}
                </div>
              )}
              <div className="flex flex-col">
                <span className="font-semibold">
                  {linkedAccount?.firstName} {linkedAccount?.lastName}
                </span>
                <span className="font-medium text-xs text-light-black capitalize">
                  {EnumUserTypes[linkedAccount?.userType]
                    ?.replace("_", " ")
                    .toLowerCase()}{" "}
                  Account
                </span>
              </div>
            </div>
            {/* Online Badge */}
            <div className="flex items-center justify-center font-medium text-xs bg-[#B0B4B840] text-[#5F666C] border border-[#B0B4B8] px-2 py-1 rounded-full">
              Inactive session
            </div>
          </div>
        </>
      ) : (
        <div className="flex flex-col gap-3 bg-white rounded-md p-3 flex-1">
          <span className="font-semibold text-sm">
            Earn commission from your network of professionals
          </span>
          <span className="font-medium text-primary text-xs leading-[20px]">
            Register now and start earning a passive income, its that easy!{" "}
            <br />
            <Link
              to={"/add-referral-account"}
              className="cursor-pointer text-blue-400"
            >
              Click here to learn more.
            </Link>
          </span>
        </div>
      )}
    </>
  );
};

export default SwitchAccountSection;
